import Vue from 'vue';
import Vuex from 'vuex';
import { http } from '@/core/api/';
import VuexPersistence from "vuex-persist";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  key: "vuex-student-comments",
  storage: window.localStorage,
});

const commentsStore = new Vuex.Store({
  state: {
    filters: {
      studentSieId: null,
      moduleId: null,
      categoryId: null,
    },
    modulesCatalogue: [],
    categoriesCatalogue: [],
  },
  getters: {
    filters: (state) => state.filters,
    modules: (state) => state.modulesCatalogue,
    categoriesCatalogue: (state) => state.categoriesCatalogue,
    categories: (state) => {
      if (!state.filters.moduleId) return [];

      return state.categoriesCatalogue.filter(x => x.moduleId == state.filters.moduleId)
    },
    selectedModule: (state) => {
      if (!state.filters.moduleId) return null;

      return state.modulesCatalogue.find(x => x.id.toLowerCase() == state.filters.moduleId.toLowerCase())
    },
    selectedCategory: (state) => {
      if (!state.filters.categoryId) return null;

      return state.categoriesCatalogue.find(x => x.id == state.filters.categoryId)
    },
  },
  mutations: {
    reset(state) {
      state.filters.studentSieId = null;
      state.filters.moduleId = null;
      state.filters.categoryId = null;
    },
    setSelectedModule(state, moduleId) {
      state.filters.moduleId = moduleId;
    },
    setSelectedCategory(state, categoryId) {
      state.filters.categoryId = categoryId ? parseInt(categoryId) : null;
    },
    updateFilters(state, payload) {
      if (payload?.studentSieId !== undefined && payload.studentSieId != state.filters.studentSieId) {
        state.filters.studentSieId = payload.studentSieId;
      }

      if (payload?.moduleId !== undefined && payload.moduleId != state.filters.moduleId) {
        state.filters.moduleId = payload.moduleId;
      }

      if (payload?.categoryId !== undefined && payload?.moduleId === undefined) {
        const selectedCategory = state.categoriesCatalogue?.find(x => x.id == payload?.categoryId);
        if (!!selectedCategory) {
          state.filters.moduleId = selectedCategory.moduleId;
        }
      }

      if (payload?.categoryId !== undefined && payload.categoryId != state.filters.categoryId) {
        state.filters.categoryId = payload.categoryId ? parseInt(payload.categoryId) : null;
      }
    },
    setCatalogues(state, payload) {
      state.modulesCatalogue = payload.modules;
      state.categoriesCatalogue = payload.categories;
    },
  },
  actions: {
    async init({ commit }, payload = {}) {
      const { enabledToAdd, categoryReadOnly, ...filterPayload } = payload;
      const useAddCommentCatalogues =
        enabledToAdd === true && categoryReadOnly !== true;
      const path = useAddCommentCatalogues
        ? 'api/code/getcommentcatalogues/True'
        : 'api/code/getcommentcatalogues';
      const response = await http.get(path);
      commit('setCatalogues', response.data);
      commit('updateFilters', filterPayload);
    },
  },
  plugins: [vuexLocal.plugin]
});

export default commentsStore;